import React from 'react'
import {
  CarouselPage,
  ConnectUsbPage,
  DriverNotFoundPage,
  DriverSuccessPage,
  HpSoftwarePage,
  InstallDriverPage,
  InstallPage,
  NotFoundPage,
  InstallDriversLandingPage,
  PrinterSpecificLandingPage,
  SearchPage,
  SelectUsbOnDisplayPage,
  SimpleLandingPage,
  StartAirprintPage,
  UnsupportedOsPage,
  DownloadingDriverPage
} from '../pages/LazyPages'
import TrilliumUnsupportedOsPage from '../pages/TrilliumUnsupportedOsPage'
import InstallChina from '../pages/install/InstallChina'
import { ContentStackTypes, Instructions } from '../store/Constants'

export const FlowRoutes = {
  search: <SearchPage />,
  'search-mobile': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_search_mobile}
    />
  ),
  'search-mac': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_search_mac}
    />
  ),
  'device-not-listed': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_device_not_listed}
    />
  ),
  'easy-start': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_easy_start}
    />
  ),
  laserjet: (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_laserjet}
    />
  ),
  paas: (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_paas}
    />
  ),
  'usb-only': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_usb_only}
    />
  ),
  'install-hp-app': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_install_hp_app}
    />
  ),
  'general-unsupported-os': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_search_unsupported_os}
    />
  ),
  'printer-specific-landing-page': <PrinterSpecificLandingPage />,
  // Will be removed in next deployment
  'flowers-landing-page': <InstallDriversLandingPage />,
  'install-drivers-landing-page': <InstallDriversLandingPage />,
  'basic-driver-landing-page': (
    <SimpleLandingPage
      contentType={ContentStackTypes.simple_landing_page_basic_driver}
    />
  ),
  'load-paper': (
    <CarouselPage
      key={Instructions.load_paper}
      instruction={Instructions.load_paper}
    />
  ),
  'install-ink': (
    <CarouselPage
      key={Instructions.install_ink}
      instruction={Instructions.install_ink}
    />
  ),
  alignment: (
    <CarouselPage
      key={Instructions.alignment}
      instruction={Instructions.alignment}
    />
  ),
  purger: (
    <CarouselPage key={Instructions.purger} instruction={Instructions.purger} />
  ),
  printheads: (
    <CarouselPage
      key={Instructions.printheads}
      instruction={Instructions.printheads}
    />
  ),
  'skyline-download-driver': (
    <CarouselPage
      key={Instructions.hp_software}
      instruction={Instructions.hp_software}
    />
  ),
  'hp-software': <HpSoftwarePage />,
  'hp-software-trillium': (
    <CarouselPage
      key={Instructions.hp_software}
      instruction={Instructions.hp_software}
    />
  ),
  'usb-printer-display': <SelectUsbOnDisplayPage />,
  'connect-usb': <ConnectUsbPage />,
  'download-driver': <InstallDriverPage />,
  'downloading-driver': <DownloadingDriverPage />,
  'driver-success': <DriverSuccessPage />,
  'driver-not-found': <DriverNotFoundPage />,
  'not-found': <NotFoundPage />,
  'unsupported-os': <UnsupportedOsPage />,
  'flowers-zeus-unsupported-os': <UnsupportedOsPage />,
  'trillium-unsupported-os': <TrilliumUnsupportedOsPage />,
  install: <InstallPage />,
  'install-china': <InstallChina />,
  'install-unsupported-os': <UnsupportedOsPage />,
  'start-airprint': <StartAirprintPage />
}
